export const SPECIAL_KEYS = Object.freeze({
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  CAPS_LOCK: 20,
  ESC: 27,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  INSERT: 45,
  DELETE: 46,
  WINDOWS: 91
});

export const SPECIAL_KEYS_EDITION = Object.freeze({
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  CAPS_LOCK: 20,
  ESC: 27,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  INSERT: 45,
  DELETE: 46,
  WINDOWS: 91
});

export const isSpecialKey = keyCode => Object.values(SPECIAL_KEYS).includes(keyCode);
export const isKeyCodeNumber = keyCode => keyCode >= 48 && keyCode <= 57;
export const isKeyCodeNumpadNumber = keyCode => keyCode >= 96 && keyCode <= 105;
